import { BrowserRouter, Routes, Route } from 'react-router-dom';
import axios from 'axios';

import Home from './screens/Home';
import Register from './screens/auth/Register';
import Login from './screens/auth/Login';
import VerifyEmail from './screens/auth/VerifyEmail';
import Profile from './screens/auth/Profile';



import Error from './screens/Error';

import './App.css';
import ProtectedRoute from './components/ProtectedRoute';
import ResetPassword from './screens/auth/ResetPassword';
import ForgotPassword from './screens/auth/ForgotPassword';
import { ToastContainer } from 'react-toastify';
import Navbar from './components/Navbar';
import AllUsers from './screens/AllUsers';
import Chats from './screens/Chats';
import Chat from './screens/Chat';

axios.defaults.withCredentials = true;


function App() {
  
  return (
    <>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/register" element={<Register />} />
          <Route exact path="/verify-email" element={<VerifyEmail />} />
          <Route exact path="/forgot-password" element={<ForgotPassword />} />
          <Route exact path="/reset-password" element={<ResetPassword />} />

          <Route exact path="/profile" element={<ProtectedRoute> <Profile /></ProtectedRoute>} />
          <Route exact path="/users" element={<ProtectedRoute> <AllUsers /></ProtectedRoute>} />
          <Route exact path="/chats" element={<ProtectedRoute> <Chats /></ProtectedRoute>} />
          <Route exact path="/chat/:id" element={<ProtectedRoute> <Chat /></ProtectedRoute>} />


          <Route exact path="*" element={<Error />} />
        </Routes>
        <ToastContainer />
      </BrowserRouter>
    </>
  );
}

export default App;
